<template>
  <div class="content-tab sysbackup">
    <div class="content-body">
      <scrollbar ref="scrollbar" class="scrollbar-body">
        <div class="formRow">
          <div class="dialog-title">{{$t('systemBackup.backupTitle')}}</div>
          <div class="dialog-content">
            <div class="dialog-content-title">{{$t('systemBackup.backupContent')}}</div>
            <button class="q-button" type="submit" :title="$t('systemBackup.backupBtn')" @click="onBackupClick">{{$t('systemBackup.backupBtn')}}</button>
          </div>
        </div>
        <div class="divide"></div>
        <div class="formRow">
          <div class="dialog-title">{{$t('systemBackup.restoreTitle')}}</div>
          <div class="dialog-content">
            <div class="dialog-content-title">{{$t('systemBackup.restoreContent')}}</div>
            <div class="input-file">
              <input name="ID" class="form-control file-input" v-model="filename" type="text" :placeholder="$t('updatefw.selectfile')" readonly>
              <div class="input-btn">
                <div class="q-button update-btn" :title="$t('updatefw.browse')" @click="onBrowseClick">
                  <folder class="q-icon"/>
                  <div class="title">{{$t('updatefw.browse')}}</div>
                </div>
                <input type="file" name="file" class="choose-file" id="choose-file" ref="choose" @change="getFileValue" />
              </div>
            </div>
            <button class="q-button" type="submit" :title="$t('systemBackup.restoreBtn')" @click="onRestoreClick" :disabled="!isRestoreBtnEnabled">{{$t('systemBackup.restoreBtn')}}</button>
          </div>
        </div>
        <div class="divide"></div>
        <div class="formRow">
          <div class="dialog-title">{{$t('systemBackup.passwordReset')}}</div>
          <div class="dialog-content">
            <div class="dialog-content-title">{{$t('systemBackup.passwordResetContent')}}</div>
            <button class="q-button blue-btn-full" :title="$t('systemBackup.passwordReset')" @click="onResetClick('pwd_reset')">{{$t('systemBackup.passwordReset')}}</button>
          </div>
        </div>
        <div class="formRow factory_reset">
          <div class="dialog-title">{{$t('systemInfo.factoryReset')}}</div>
          <div class="dialog-content">
            <div class="dialog-content-title">{{$t('systemBackup.factoryResetContent')}}</div>
            <button class="q-button blue-btn-full" :title="$t('systemInfo.factoryReset')" @click="onResetClick('factory_reset')">{{$t('systemInfo.factoryReset')}}</button>
          </div>
        </div>
      </scrollbar>
    </div>
    <popup-confirm name="restore-modal" :dialog-header="$t('systemBackup.restoreTitle')" :dialog-message="$t('systemBackup.restoreMsg')" type="w" :callback="goRestore" icon="w"/>
    <popup-confirm name="reset-modal" :dialog-header="dialogHeader" :dialog-message="dialogMsg" type="w" :callback="goReset" icon="w"/>
    <!-- <popup-confirm name="warning-modal" :dialog-header="errorMsg" type="w" icon="w" :onlyOk=true /> -->
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex'
import folder from '../assets/svg/folder.svg'
export default {
  name: 'sysbackup',
  components: {
    folder
  },
  data () {
    return {
      isRestoreBtnEnabled: false,
      filename: null,
      errorMsg: this.$t('systemBackup.restoreError'),
      dialogMsg: '',
      dialogHeader: '',
      localStorageHostname: 'qsw_hostname'
    }
  },
  methods: {
    ...mapActions(['getSystemConfig', 'restoreSystemConfig', 'setSwitchAction', 'getSystemInfo']),
    ...mapMutations(['openModal', 'closeModal']),
    getFileValue (event) {
      this.filename = document.getElementById('choose-file').files[0].name
      let fileExten = this.filename.split('.')
      if (fileExten[fileExten.length - 1] === 'conf') {
        this.isRestoreBtnEnabled = true
      } else {
        this.isRestoreBtnEnabled = false
      }
    },
    async checkToken () {
      await this.getSystemInfo()
    },
    onBrowseClick () {
      this.$refs.choose.click()
    },
    async onBackupClick () {
      this.$store.commit('updateFullLoadingStatus', true)
      await this.checkToken()
      this.getSystemConfig().then((res) => {
        var elem = window.document.createElement('a')
        elem.href = window.URL.createObjectURL(res.data)
        elem.download = this.$localStorage.get(this.localStorageHostname) + '.conf'
        document.body.appendChild(elem)
        elem.click()
        document.body.removeChild(elem)
        window.URL.revokeObjectURL(res.data)
        this.$store.commit('updateFullLoadingStatus', false)
      }).catch((err) => {
        this.$log.error(err)
        this.$store.commit('updateFullLoadingStatus', false)
      })
    },
    async onRestoreClick () {
      await this.checkToken()
      this.openModal('restore-modal')
      this.$modal.show('restore-modal')
    },
    async onResetClick (type) {
      await this.checkToken()
      if (type === 'pwd_reset') {
        this.dialogHeader = this.$t('systemBackup.passwordReset')
        this.dialogMsg = this.$t('systemBackup.passwordResetAlert')
      } else {
        this.dialogHeader = this.$t('systemInfo.factoryReset')
        this.dialogMsg = this.$t('systemInfo.factoryResetAlert')
      }
      this.openModal('reset-modal')
      this.$modal.show('reset-modal')
    },
    goRestore () {
      this.closeModal('restore-modal')
      this.$modal.hide('restore-modal')
      let file = document.getElementById('choose-file').files[0]
      if (file) {
        let form = new FormData()
        form.append('conf', file)
        this.$store.commit('setLoadingType', 'restore')
        this.$store.commit('updateFullLoadingStatus', true)
        this.restoreSystemConfig(form).then((result) => {
          this.$store.commit('setUpdateStatus', false)
          this.$parent.$parent.checkRebootingStatus(true)
        }).catch((err) => {
          this.$log.error(err)
          this.$store.commit('setLoadingType', '')
          this.$store.commit('updateFullLoadingStatus', false)
          this.$store.commit('setErrorWin', {
            show: true,
            data: {
              error_message: (err.response.status === 400) ? this.$t('errorMessage.restoreFileError') : this.$t('errorMessage.restoreSystemError')
            },
            title: this.$t('errorMessage.restoreSystemError')
          })
        })
      }
    },
    goReset () {
      this.$store.commit('setLoadingType', 'reset')
      this.$store.commit('updateFullLoadingStatus', true)
      let command = (this.dialogMsg === this.$t('systemBackup.passwordResetAlert')) ? 'reset_passwd' : 'reset_system'
      this.setSwitchAction(command).then(res => {
        this.$log.info('setSwitchAction')
        this.$log.debug('setSwitchAction', res)
        this.$parent.$parent.checkRebootingStatus(true)
      })
      this.closeModal('reset-modal')
      this.$modal.hide('reset-modal')
    }
  },
  computed: {
    ...mapState({
      sysBoard: state => state.module.sysBoard,
      fwinfo: state => state.module.fwinfo
    })
  }
}
</script>

<style lang="scss" scoped deep>
.content-tab.sysbackup {
  position: relative;
  background-color: #fff;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  .content-body {
    position: relative;
    width: 100%;
    padding: 20px 10px 10px 10px;
    .dialog-title {
      user-select: none;
      margin-bottom: 10px;
      font-size: 16px;
      line-height: 16px;
      font-weight: bold;
    }
    .dialog-content-title {
      margin-bottom: 15px;
    }
    .divide {
      border-top: 1px solid #979797;
      margin: 20px 0px;
    }
    .input-file {
      margin-bottom: 15px;
      display: flex;
      .file-input {
        width: 385px;
        margin: 0px;
        background-color: #ffffff;
      }
      .q-button {
        margin-left: 10px;
      }
      .choose-file {
        display: none;
      }
      .update-btn {
        display: flex;
        justify-content: center;
        border-width: 0px;
        color: #ffffff;
        background-image: linear-gradient(180deg, #4E8FE2 0%, #3475C6 97%);
        border-radius: 4px;
        border-radius: 4px;
        &:hover {
          background-image: linear-gradient(180deg, #59A0FA 3%, #3F8DED 94%);
        }
        &:active {
          background: #324EAD;
        }
        &:disabled {
          background: rgba(169,169,169,0.30);
        }
        .title {
          line-height: 20px;
          margin-left: 5px;
          margin-right: 0px;
        }
      }
    }
    .scrollContainer > .scrollbar {
      margin-right: 10px;
    }
    .scrollbar-body {
      height: 100%;
      padding: 0px 10px;
      & /deep/ .scroll-content {
        margin-right: 15px;
      }
    }
    .factory_reset {
      margin-top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SystemBackup.vue